import { createTheme, MantineColorsTuple } from '@mantine/core'

// Brand orange color palette (#FFA51A as base)
const brandOrange: MantineColorsTuple = [
  '#fff0db', // 0 - lightest (improved contrast)
  '#ffe2b8', // 1 (improved contrast)
  '#ffce94', // 2 (improved contrast)
  '#ffb870', // 3 (improved contrast)
  '#ffa94d', // 4
  '#ff922b', // 5
  '#FFA51A', // 6 - main brand color (for non-button uses)
  '#e68a14', // 7 - better contrast for filled buttons (improved)
  '#cc7911', // 8 - darker hover state (improved)
  '#b36a0d', // 9 - darkest (improved)
]

// Light blue accent palette (improved contrast)
const brandBlue: MantineColorsTuple = [
  '#e7f5ff', // 0
  '#d0ebff', // 1
  '#a5d8ff', // 2
  '#7fc5f7', // 3 - main accent color (improved contrast)
  '#5ab3f5', // 4 (improved contrast)
  '#3ca0f2', // 5 (improved contrast)
  '#2089e0', // 6 (improved contrast)
  '#1c7acc', // 7 (improved contrast)
  '#186bb8', // 8 (improved contrast)
  '#145ca3', // 9 (improved contrast)
]

// Dark brown text palette (#3e2c09 as base)
const brandBrown: MantineColorsTuple = [
  '#faf4eb',
  '#f3e5d0',
  '#e8d4b1',
  '#dbc08d',
  '#cfac6a',
  '#c49849',
  '#785628', // slightly lighter
  '#3e2c09', // main dark brown
  '#2e2107',
  '#1f1605',
]

export const theme = createTheme({
  primaryColor: 'brandOrange',
  primaryShade: { light: 8, dark: 6 }, // Use shade 8 for better contrast in light mode
  colors: {
    brandOrange,
    brandBlue,
    brandBrown,
  },
  defaultRadius: 'lg',
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  headings: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontWeight: '700',
  },
  shadows: {
    xs: '0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1)',
    sm: '0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.06)',
    md: '0 8px 16px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.06)',
    lg: '0 16px 24px rgba(0, 0, 0, 0.12), 0 6px 12px rgba(0, 0, 0, 0.06)',
    xl: '0 24px 32px rgba(0, 0, 0, 0.14), 0 12px 16px rgba(0, 0, 0, 0.08)',
  },
  components: {
    Button: {
      defaultProps: {
        size: 'md',
        radius: 'lg',
      },
      styles: {
        root: {
          fontWeight: 600,
          transition: 'all 0.2s ease',
        },
      },
    },
    TextInput: {
      defaultProps: {
        size: 'md',
        radius: 'md',
      },
    },
    Paper: {
      defaultProps: {
        radius: 'lg',
        shadow: 'sm',
      },
    },
    Card: {
      defaultProps: {
        radius: 'lg',
        shadow: 'sm',
      },
    },
    Checkbox: {
      defaultProps: {
        radius: 'sm',
      },
    },
  },
})

// TypeScript module augmentation for custom colors
declare module '@mantine/core' {
  export interface MantineThemeColorsOverride {
    colors: Record<string, MantineColorsTuple>
  }
}
